<div class="row">
	<div class="col-md-12">
		<cache-date></cache-date>
	</div>
</div>
	
<div class="row">
	<div class="col-md-12">
		<filterForm [addFilterParams]="filter.addFilterParams"></filterForm>
	</div>
</div>


<div class="row">
	<div class="col-md-12">
		<loading [isLoad]="isLoad"></loading>
		
		<table class="table">
			<thead>
				<tr>
					<th></th>
					
					<th>desktop</th>
					<th>tablet</th>
					<th>phone</th>
				</tr>
			</thead>
			
			<tbody>
				<tr>
					<td>
						Общее количество действий
					</td>
					
					<td>
						{{ data.total.desktop | prettyNumber }}
					</td>
					
					<td>
						{{ data.total.tablet | prettyNumber }}
					</td>
					
					<td>
						{{ data.total.phone | prettyNumber }}
					</td>
				</tr>
				
				
				<tr>
					<td>
						Среднее количество действий на пользователя
					</td>
					
					<td>
						{{ data.avg.desktop | prettyNumber }}
					</td>
					
					<td>
						{{ data.avg.tablet | prettyNumber }}
					</td>
					
					<td>
						{{ data.avg.phone | prettyNumber }}
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>
